import React, { useState } from 'react';
import Button from '../../../../../Components/Button/Button';
import Modal from '../../../../../Components/Modal/Modal';
import {
	QuestionnaireResult,
	useLazyQuestionnaireResultItemsQuery,
	useLazyQuestionnaireResultsQuery,
	useLazySingleQuestionnaireResultItemsQuery,
} from '../../../../../graphql/graphql';
import List from '../../../../../Components/List/List';
import ListItem from '../../../../../Components/List/ListItem';
import FormattedDate, {
	FormattedDateTime,
} from '../../../../../Components/FormattedDate';

interface Props {
	patientId: string;
	questionnaireCode: string;
	onItemSelect: (results: any) => void;
}

const QuestionnaireResultSelection: React.FC<Props> = ({
	patientId,
	questionnaireCode,
	onItemSelect,
}) => {
	const [loadQuestionnaireResultQuery, { data, isLoading }] =
		useLazyQuestionnaireResultsQuery();
	const [loadQuestionnaireResultItems] =
		useLazySingleQuestionnaireResultItemsQuery();
	const [isModalVisible, setIsModalVisible] = useState(false);

	const handleOpenQuestionnaireResultsModal = async () => {
		await loadQuestionnaireResultQuery({
			patientId,
			questionnaireCode,
		});

		setIsModalVisible(true);
	};

	const handleSelectQuestionnaire = async (
		questionnaireResult: QuestionnaireResult,
	) => {
		const { questionnaireResultItems } = await loadQuestionnaireResultItems({
			questionnaireResultId: questionnaireResult.id,
			take: 999,
		}).unwrap();

		const results = {};

		// @ts-ignore
		questionnaireResultItems?.data?.map(
			({ question, answer, value, valueJson }) => {
				const key = question?.key || answer?.key || null;

				if (key) {
					// @ts-ignore
					results[key] =
						typeof valueJson?.rawValue !== 'undefined'
							? valueJson.rawValue
							: valueJson;
				}
			},
		);

		console.log({ results });

		onItemSelect(results);
		setIsModalVisible(false);
	};

	return (
		<>
			<div style={{ display: 'inline-block' }}>
				<Button
					title={'Vybrat dotazník pro načtení dat'}
					onClick={handleOpenQuestionnaireResultsModal}
				/>
			</div>
			<Modal opened={isModalVisible} onClose={() => setIsModalVisible(false)}>
				<Modal.Header title='Seznam vyplněných dotazníků od pacienta' />
				<Modal.Content contentScroll={true}>
					<List
						items={data?.questionnaireResults?.data}
						itemTemplate={({ item }: { item: any }) => (
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									justifyContent: 'space-between',
									marginBottom: 15,
								}}>
								<div>
									{item.questionnaire.title} - vyplněno{' '}
									<FormattedDateTime datetime={item.createdAt} />
								</div>
								<Button onClick={() => handleSelectQuestionnaire(item)}>
									Vybrat
								</Button>
							</div>
						)}
					/>
				</Modal.Content>
			</Modal>
		</>
	);
};

export default QuestionnaireResultSelection;
